import React from "react";
import HeroVideo from "../components/HeroVideo";
import FeatureIcons from "../components/FeatureIcons";
import StatsSection from "../components/StatsSection";
import ServicesGrid from "../components/ServicesGrid";
import ProcessSection from "../components/ProcessSection";
import AboutSection from "../components/AboutSection";
import Testimonials from "../components/Testimonials";
import CTASection from "../components/CTASection";

export default function Home() {
  return (
    <>
      <HeroVideo />
      <div className="bg-[#0a0a0a] py-10 flex justify-center">
        <a
          href="/robot/"
          className="group inline-flex items-center gap-4 px-10 py-5 border border-[#B87333]/60 text-[#f5ede1] text-[11px] tracking-[0.35em] font-semibold hover:bg-[#B87333] hover:text-[#0a0a0a] hover:border-[#B87333] transition-colors duration-300"
        >
          <span>⚙</span>
          YATIRIM TEŞVİK ROBOTU
          <span className="w-5 h-px bg-[#B87333] group-hover:bg-[#0a0a0a] group-hover:w-8 transition-all duration-300" />
        </a>
      </div>
      <FeatureIcons />
      <StatsSection />
      <ServicesGrid />
      <ProcessSection />
      <AboutSection />
      <Testimonials />
      <CTASection />
    </>
  );
}
